import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Coming soon...</h1>
    </div>
  );
}

export default App;
